import styled from '@emotion/styled';
import css from '@emotion/css';
import theme from '../../theme';
import { SpinnerProps } from './spinner.interfaces';

const spinnerSize = 15;

export const animationStyles = css``;

export const Spinner = styled('div')`
  width: ${spinnerSize}px;
  height: ${spinnerSize}px;
  animation: rotation 700ms linear infinite;
  position: relative;
  display: ${({ isVisible }: SpinnerProps) => (isVisible && 'inline-block') || 'none'};
  animation: rotation linear 0.9s infinite;

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const SHAPE_BORDER_TOP_COLORS = {
  primary: theme.palette.icon.primary,
  secondary: theme.palette.icon.secondary,
  tertiary: theme.palette.icon.tertiary,
  'text-primary': theme.palette.icon.textPrimary,
  'text-secondary': theme.palette.icon.textSecondary,
  contrast: theme.palette.icon.contrast,
};

const shapeBorderTopColor = ({ color }: SpinnerProps) => SHAPE_BORDER_TOP_COLORS[color];

export const Shape = styled('div')`
  position: absolute;
  width: 100%;
  height: 100%;
  border-top: 2px solid ${shapeBorderTopColor};
  border-right: 2px solid transparent;
  border-radius: 50%;
`;
